import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b80cac2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReturnSlip_operationWrapper" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "ReturnSlip_BtnBlock" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_7 = { class: "ReturnSlip_Table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "詳細", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "ta_r" }
const _hoisted_22 = { class: "ta_r" }
const _hoisted_23 = {
  key: 0,
  class: "ResultMessageNull"
}

import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { Notyf } from "notyf";
import axios from "axios";
import CsvHelper from "../functions/CsvHelper.js";

export interface ReturnSlip {
  acceptedHenpinDate: string;
  toritugiHenpinDate: string;
  toritugiDenpyouNumber: string;
  eventNumber: number;
  eventMei: string;
  hanmotoCd: string;
  toritugiKyoukaiCd: string;
  toritugiCd: string;
  toritugiMei: string;
  hannyusakiCd: string;
  hannyusakiMei: string;
  syoumiTotalPrice: number;
  growDenpyouNumber: string;
  hontaiTotalPrice: number;
  jikoDenpyouNumber: string;
  jikoDenpyouRowNumber: number;
  syosiCd: string;
  syuppanSyosiCd: string;
  isbn: string;
  title: string;
  hontaiPrice: number;
  henpinSuu: number;
  kakeritu: number;
  syoumiPrice: number;
  syouhinKbnCd: string;
  syouhinKbnMei: string;
  soukoCd: number;
  zassiCd: string;
  syubetu: string | null;
  syubetuKbn: number | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReturnSlip',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const router = useRouter();
const store = useStore();
const props = __props;
const { getTimeStamp } = CsvHelper();



//ぱんくずヘッダー
const currentPathList = [{ name: "伝票照会" }, { name: "返品伝票" }];
// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

// 全体で使用する変数--------------------------------------------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);

// テーブル表示項目----------------------------------------------
// 型定義
let searchAreaToggle: boolean = true;
let search_result = ref<ReturnSlip[]>([]);

//検索ヘッダ関連----------------------------------------------
let isActiveKaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
let isOpentoggleArea = ref<boolean>(true);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActiveKaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};

// データ取得関連---------------------------------------------
//検索処理
const onSearch = (): void => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  isSorting.value = false;
  getReturnSlipData();
};

const getReturnSlipData = async (): Promise<void> => {
  search_result.value.splice(0);
  if (isSorting.value === true) {
    await store.dispatch("search/sortReturnSlip", {
      sortItem: sortInfo.value.sortItem,
      isKoujun: sortInfo.value.isKoujun,
    });
  } else {
    await store.dispatch("search/searchReturnSlip");
  }
  const res = store.getters["search/getReturnSlipData"];
  res.mstHenpinDenpyou.forEach((henpin: ReturnSlip) => {
    search_result.value.push(henpin);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;

  getTotalPage();
};
getReturnSlipData();

// ページネーション関連処理------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);

// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};

const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getReturnSlipData();
};

// テーブルソート処理--------------------------------------------------------------------------------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;

  getReturnSlipData();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

// 詳細画面関連-----------------------------------------------
const openTab = async (jikoDenpyouNumber: string) => {
  console.log(jikoDenpyouNumber);

  let resolvedRoute = router.resolve({
    name: "ReturnSlipDetail",
    params: { id: jikoDenpyouNumber },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1200,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};

// ダウンロード関連--------------------------------------------
let isDownLoading = ref(false);
const getCsvData = async () => {
  isDownLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getReturnSlipState"];
  try {
    isDownLoading.value = true;
    const searchParams = `fromAcceptedHenpinDate=${
      detailState.fromAcceptedHenpinDate
    }&toAcceptedHenpinDate=${
      detailState.toAcceptedHenpinDate
    }&fromToritugiHenpinDate=${
      detailState.fromToritugiHenpinDate
    }&toToritugiHenpinDate=${detailState.toToritugiHenpinDate}&eventMei=${
      detailState.eventMei
    }&toritugiCd=${detailState.toritugiCd}&syosiCd=${
      detailState.syosiCd
    }&syubetu=${detailState.syouhinKbnMei}&freeword=${simpleState}&hanmotoCd=${
      store.getters["login/getUserData"].hanmotoCd
    }&page=${store.getters["search/getPageNumber"]}&numberOfDisplay=&order=${
      isSorting.value ? sortInfo.value.sortItem : ""
    }&sort=${isSorting.value ? sortInfo.value.isKoujun : ""}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/denpyou/henpin/download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    isDownLoading.value = false;
    if (res.data === "") {
      notyf.error("ダウンロードするデータがありません");
    } else {
      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `返品伝票_${getTimeStamp()}.xlsx`;
      link.click();
      isDownLoading.value = false;
    }
  } catch (error) {
    isDownLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
// レイアウト関連----------------------------------------------
//テーブルの高さ判定
const tableHeight = () => {
  if (isActive_SyosaiFlg.value && isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "ReturnSlip_TableContainer_Short";
  } else {
    //その他
    return "ReturnSlip_TableContainer_Long";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ReturnSlip", {
      Show_KaniSearch: _unref(isActiveKaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActiveKaniFlg: _unref(isActiveKaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      searchType: "returnSlip",
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea,
      onOnSearch: onSearch
    }, null, 8, ["isActiveKaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, _unref(search_result).length]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["ReturnSlip_BtnGray", { ReturnSlip_BtnDisabled: _unref(isDownLoading) }]),
          download: "sample.txt",
          onClick: getCsvData,
          disabled: _unref(isDownLoading)
        }, [
          (!_unref(isDownLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isDownLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _hoisted_6
        ], 10, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["ReturnSlip_TableContainer", tableHeight()])
    }, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("th", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sortTable('hanmotoCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 版元"),
              _hoisted_9,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hanmotoCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('acceptedHenpinDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 返品受領日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("acceptedHenpinDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('toritugiHenpinDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 取次返品日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiHenpinDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable('toritugiDenpyouNumber'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 取次伝票"),
              _hoisted_10,
              _createTextVNode("NO"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiDenpyouNumber")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('eventMei'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" イベント名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("eventMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('toritugiKyoukaiCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 取次協会"),
              _hoisted_11,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiKyoukaiCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('toritugiCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 取次"),
              _hoisted_12,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('toritugiMei'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 取次名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('hannyusakiCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 搬入先"),
              _hoisted_13,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hannyusakiCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('hannyusakiMei'))),
              class: "TH_Normal th_sort"
            }, [
              _createTextVNode(" 搬入先名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hannyusakiMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable('growDenpyouNumber'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" GROW伝票"),
              _hoisted_14,
              _createTextVNode("NO"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("growDenpyouNumber")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable('jikoDenpyouNumber'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 自己伝票"),
              _hoisted_15,
              _createTextVNode("NO"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("jikoDenpyouNumber")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (sortTable('syoumiTotalPrice'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 正味金額"),
              _hoisted_16,
              _createTextVNode("合計"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("syoumiTotalPrice")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (sortTable('hontaiTotalPrice'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 本体価格"),
              _hoisted_17,
              _createTextVNode("合計"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hontaiTotalPrice")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (sortTable('soukoCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 倉庫"),
              _hoisted_18,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("soukoCd")), 1)
            ])
          ])
        ]),
        (_unref(search_result).length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (openTab(result.jikoDenpyouNumber)),
                      class: "ReturnSlip_Table_Button"
                    }, " 詳細 ", 8, _hoisted_20)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(result.hanmotoCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.acceptedHenpinDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiHenpinDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiDenpyouNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(result.eventMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiKyoukaiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.hannyusakiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.hannyusakiMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.growDenpyouNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(result.jikoDenpyouNumber), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(result.syoumiTotalPrice !== null
                  ? result.syoumiTotalPrice.toLocaleString()
                  : result.syoumiTotalPrice), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(result.hontaiTotalPrice !== null
                  ? result.hontaiTotalPrice.toLocaleString()
                  : result.hontaiTotalPrice), 1),
                  _createElementVNode("td", null, _toDisplayString(result.soukoCd), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_unref(search_result).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})